import { render, staticRenderFns } from "./view_user.vue?vue&type=template&id=19e23550"
import script from "./view_user.vue?vue&type=script&lang=js"
export * from "./view_user.vue?vue&type=script&lang=js"
import style0 from "./view_user.vue?vue&type=style&index=0&id=19e23550&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports